import styled from "styled-components/macro";

import { useUserData } from "Flocknote/apiHooks";

import FnrTypography from "FnrTypography";

import { formatPhoneNumberWithoutCountryCode } from "Utilities/Number/formatPhoneNumber";

import { useFontColor } from "./stateHooks";

const Data = () => {
  const [{ fname, lname, emailInfo, phoneInfo }] = useUserData();
  const email = emailInfo?.email;
  const phone = phoneInfo?.phone;
  const fontColor = useFontColor();

  return (
    <OuterWrapper>
      <DataWrapper>
        <NameAndProfileLinkWrapper>
          {Boolean(fname || lname) && (
            <SFnrTypography
              type="subheader"
              noWrap
              fontSize="xl"
              color={fontColor}
            >
              {fname} {lname}
            </SFnrTypography>
          )}
        </NameAndProfileLinkWrapper>
        <SubDataWrapper>
          {Boolean(email) && (
            <SFnrTypography type="copy" color={fontColor}>
              {email}
            </SFnrTypography>
          )}
          {Boolean(phone) && (
            <SFnrTypography noWrap type="number" color={fontColor}>
              {formatPhoneNumberWithoutCountryCode(phone)}
            </SFnrTypography>
          )}
        </SubDataWrapper>
      </DataWrapper>
    </OuterWrapper>
  );
};

const OuterWrapper = styled.div`
  display: flex;
  flex-direction: column;
`;

const SFnrTypography = styled(FnrTypography)`
  text-overflow: ellipsis;
  overflow: hidden;
`;

const DataWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  overflow: hidden;
`;

const NameAndProfileLinkWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
`;

const SubDataWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2px;
`;

export default Data;
